module.exports = __webpack_public_path__ + "static/media/marketing-square.1ebee6f6.jpg";